/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// getAllReferralsSections
// GETALLREFERRALSSECTIONS
const GETALLREFERRALSSECTIONS= createAsyncThunk(
  "getAllReferralsSections/getAllReferralsSections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllReferralsSectionsSlice = createSlice({
  name: "getAllReferralsSectionsSlice",
  initialState: {
    PublishPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GETALLREFERRALSSECTIONS.fulfilled, (state, action) => {
      state.getAllReferralsSections = {
        ...state.getAllReferralsSections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONS.pending, (state, action) => {
      state.getAllReferralsSections = {
        ...state.getAllReferralsSections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONS.rejected, (state, action) => {
      state.getAllReferralsSections = {
        ...state.getAllReferralsSections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllReferralsSectionsAction = {
  GETALLREFERRALSSECTIONS,
};

export { getAllReferralsSectionsAction };
export default getAllReferralsSectionsSlice.reducer;
